export enum LocationSortFieldEnum {
    CHARGER_SIZE = 'CHARGER_SIZE',
    CITY = 'CITY',
    COUNTRY = 'COUNTRY',
    ID = 'ID',
    LOCATION_TYPE = 'LOCATION_TYPE',
    NAME = 'NAME',
    STREET = 'STREET',
    USERS_SIZE = 'USERS_SIZE',
}

export enum LocationType {
    RESIDENTIAL = 'RESIDENTIAL',
    COMMERCIAL = 'COMMERCIAL',
    LOGISTICS = 'LOGISTICS',
    INDUSTRIAL = 'INDUSTRIAL',
}
